import { configureStore } from '@reduxjs/toolkit';
import { createStateSyncMiddleware, initStateWithPrevTab } from 'redux-state-sync';

import rootReducer from '@editor2/reducers/root';
import { useDispatch } from 'react-redux';

const config = {
	blacklist: [
		'toast/showToast',
		'tableOfContents/editChaptersCollapseState',
		'tableOfContents/editPageGroupsCollapseState',
		'tableOfContents/editElementsCollapseState',
		'tableOfContents/setShowConflictsModal'
	]
};
const stateSyncMiddleware = [createStateSyncMiddleware(config)];

const initStateReceived = (storeAPI) => (next) => (action) => {
	// in case other courses are already opened
	if (action.type === '&_RECEIVE_INIT_STATE') {
		return next({
			...action,
			payload: {
				...action.payload,
				tabsSync: {
					initStateReceived: true
				}
			}
		});
	}

	return next(action);
};

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(stateSyncMiddleware).concat(initStateReceived)
});

initStateWithPrevTab(store);
